<template>
    <div class="modal_offer_create_wrap" v-if="dialog">
        <v-card>
          <v-card-title>
            <span class="headline">Create Offers</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col
                    cols="12"
                    sm="12"
                >
                  <v-text-field
                      v-model="createOfferData.name"
                      label="Offer Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="3">Type</v-col>
                <v-col
                    cols="12"
                    lg="5"
                >
                  <v-switch
                      v-model="createOfferData.type"
                      true-value="regular"
                      false-value="aggregated"
                      :label="createOfferData.type"
                      class="edit-modal-switch"
                  >
                  </v-switch>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="secondary"
                    text
                    @click="closeModalCreatOffer"
                >
                  Cancel
                </v-btn>
                <v-btn

                    color="primary"
                    text
                    @click="createOffer"
                >
                  Create
                </v-btn>
              </v-card-actions>

            </v-container>
          </v-card-text>

        </v-card>

      </div>
</template>

<script>
import store from "@/store";
import {mapMutations} from 'vuex'

export default {
  name: "NewOffer",
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  model: {
    prop: 'open',
    event: 'toggle'
  },
  data() {
    return {
      dialog: this.open,
      mute: true,
      createOfferData: {
        name: '',
        type: 'regular'
      },
    }
  },
  async mounted() {
    this.dialog = this.open
  },
  methods: {
    ...mapMutations('offer', [
      'clearGeo',
      'cancelGeo'
    ]),
    async createOffer() {
      if (!this.createOfferData.name) {
        await this.$dialog.error({
          text: `Offer name is empty`,
          title: 'Validation Error'
        })
        return
      }

      let resDb = await store.dispatch('offer/createOffer', {
        name: this.createOfferData.name,
        type: this.createOfferData.type
      })

      this.clearGeo();

      if (resDb && resDb.id) {
        if (this.createOfferData.type === 'aggregated'){
          await this.$router.push(`/advertisers/aggregatedOffer/${resDb.id}`);
        } else {
          // await this.$router.push(`/advertisers/offer/${resDb.id}`);
          await this.$router.push(`/advertisers/offerV2/${resDb.id}`);
        }

      }

      this.dialog = !this.dialog
    },
    async closeModalCreatOffer(){
      this.dialog = !this.dialog
    }
  },
  watch: {
    dialog() {
      this.$emit('toggle', this.dialog);
    },
    open() {
      this.dialog = this.open
    }
  },
}
</script>

<style scoped lang="sass">
.create_offer_name_input
  color: #7f98a5
  height: 31px
  width: 500px
  border: 1px solid rgba(60,60,60,.26)
  border-radius: 4px
  white-space: normal
  padding: 0 10px
  &:focus
    outline: none

.modal_offer_create_wrap
  position: fixed
  top: 0
  left: 0
  z-index: 100
  display: flex
  width: 100%
  height: 100%
  justify-content: center
  align-items: center
  background: rgba(0,0,0,.6)

</style>
